import { openModal } from "action/modal/openModal";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import { useDispatch, useSelector } from "react-redux";
import HideIf from "util/HideIf";
import { useState, useEffect } from "react";
import styles from "./SwitchLanguage.module.scss";

const AfterScrollDesktopHeader = dynamic(() => import(/* webpackChunkName: "header-desktop-after" */ "./AfterScrollDesktopHeader"));

function DesktopHeader(props: any) {
  const {
    liveChat, onClickLogin, onClickSignup, showSlideMenu, onHideSlideMenu, chat, openSlideMenu,
  } = props;

  const { t } = useTranslation("common");
  const [showStickyHeader, setShowStickyHeader] = useState(false);
  const { businessCustomer } = useSelector((store: RootState) => store.authenticationState);
  const dispatch = useDispatch();
  function listenScrollEvent() {
    setShowStickyHeader(window.pageYOffset > 115);
  }

  useEffect(() => {
    listenScrollEvent();
    window.addEventListener("scroll", listenScrollEvent);
    return () => {
      window.removeEventListener("scroll", listenScrollEvent);
    };
  }, []);

  return (
    <>
      {/* Hide Feedback for B2B customer */}
      <HideIf show={!businessCustomer}>
        <div
          onClick={(e) => {
            e.preventDefault();
            dispatch(openModal("feedbackModal", {
              onClose: () => {},
            }));
          }}
          id="quick-feedback"
          className={styles.feedbackButton}
        >
          {t("Feedback")}
        </div>
      </HideIf>
      {showStickyHeader && (
        <AfterScrollDesktopHeader
          {...{
            liveChat, onClickLogin, onClickSignup, showSlideMenu, onHideSlideMenu, chat, openSlideMenu,
          }}
        />
      )}
    </>

  );
}

export default DesktopHeader;
